<template>
  <div>
    <common-dialog
      ref="dialog"
      width="700px"
      :show-save-button="$permission.canEdit()"
      unit="轮播图"
      edit-title
      id-key="RecordId"
      :data="data"
      form-label-width="95px"
      :form-rules="rules"
      :save-func="api.save"
      @create-opened="onCreateOpened"
      @edit-opened="onEditOpened"
      close-on-saved
      :before-save="onBeforeSave"
      :get-data-func="api.info"
      @closed="onClosed"
      @close-saved="$emit('close-saved')"
    >
      <template slot="form">
        <el-row>
          <el-col :span="isMB ? 24 : 12">
            <el-form-item label="图片名称" prop="PhotoName">
              <el-input
                v-model="data.PhotoName"
                placeholder="请填写图片名称"
                clearable
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="isMB ? 24 : 12">
            <el-form-item label="所属栏目" prop="BelongColumn">
              <el-select
                v-model="data.BelongColumn"
                placeholder="请选择所属栏目"
                clearable
                @change="changeBelongColumn"
              >
                <el-option label="首页" :value="1"></el-option>
                <el-option label="资源广场" :value="2"></el-option>
                <el-option label="项目招商" :value="3"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
   
        <el-row>
          <el-col :span="24">
            <el-form-item label="图片" prop="PhotoAddress">
              <single-pic-upload
                v-model="data.PhotoAddress"
                type="PhotoAddress"
                :uploadUrl="uploadUrl"
              ></single-pic-upload>
              <span style="color: red">最佳宽高比例9:4</span>
            </el-form-item>
          </el-col>
        </el-row>
       

        <el-row>
          <el-col :span="isMB ? 24 : 12">
            <el-form-item label="序号" prop="OrderId">
              <el-input-number v-model="data.OrderId" :min="0" />
            </el-form-item>
          </el-col>
          <el-col :span="isMB ? 24 : 12">
            <el-form-item label="状态" prop="State">
              <el-radio-group v-model="data.State">
                <el-radio :label="1">启用</el-radio>
                <el-radio :label="0">停用</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>
       
      </template>
      <template #footer v-if="!$permission.canEdit()">
        <el-button @click="close">关 闭</el-button>
      </template>
    </common-dialog>
    <goods-dialog
      ref="goodsDialog"
      in-dialog
      selectable
      :multiple="false"
      @select="setGoods"
    />
  </div>
</template>
  <script>
import editDialogMixin from "@/mixins/editDialog";
import commonDialog from "@/components/common/dialog";
import singlePicUpload from "@/components/common/photo/singleUpload";
import businessSelect from "@/components/shop/business/select";
import treeSelect from "@/components/common/treeSelect";
import goodsDialog from "@/components/goods/info/listDialog";

export default {
  mixins: [editDialogMixin],
  components: {
    commonDialog,
    singlePicUpload,
    businessSelect,
    treeSelect,
    goodsDialog,
  },
  data() {
    return {
      data: {
        RecordId: 0,
        BelongColumn: 1,
        PhotoName: "",
        PhotoAddress: "",
        OrderId: 0,
        State: 1,
      },

      api: require("@/api/store/loopphoto").default,
      api2: require("@/api/goods/type").default,

      isMB: this.$store.state.isMB,
      rules: {
        PhotoName: [{ required: true, message: "图片名称不能为空" }],
        PhotoAddress: [{ required: true, message: "图片不能为空" }],

        OrderId: [{ required: true, message: "序号不能为空" }],
      },
      uploadUrl: "/api/Common/UploadPicture",
      loginInfo: JSON.parse(localStorage.getItem("loginInfo")),
      TypePlatforms: [],
      props: {
        value: "RecordId",
        label: "TypeName",
        children: "children",
      },
    };
  },
  
  // watch: {
  //   //监听
  //   "data.StoreId": {
  //     //监听AdType的值，
  //     handler(val,oldVal) {
  //       if (val) {
  //         if(this.data.RecordId>0){
            
  //         }else{
  //           this.data.GoodsTypeId=null;
  //         }
  //         this.getOption()
  //       }
  //     },
  //   },
  // },
  methods: {
    getOption() {
      // var param = { State: 1 };
      // if (this.loginInfo.UserType == 0) {
      //   param.StoreId = this.data.StoreId;
      // }
      // this.api2.list(param).then((res) => {
      //   if (res.Code == 0) {
      //     this.TypePlatforms = this.$commonJs.toTreeData(
      //       res.Data,
      //       "RecordId",
      //       "TypeIdParent",
      //       "children"
      //     );
      //     if (this.$refs.treeSelect) {
      //       this.$refs.treeSelect.setData();
      //     }
      //   }
      // });
    },
    onGoodsDialog() {
      var param = { SaleState: 1 };
      if (this.loginInfo.UserType == 0) {
        param.StoreId = this.data.StoreId;
      }
      this.$refs.goodsDialog.open().then((that) => {
        that.getData(param);
        that.getTree();
      });
    },
    setGoods(t) {
      console.log(t, "setgoods");
      this.data.GoodsId = t.RecordId;
      this.data.GoodsName = t.GoodsName;
    },
    onTreeSelect(t) {
      if (!t) {
        this.data.GoodsTypeName = "";
        this.data.GoodsTypeId = null;
      } else {
        this.data.GoodsTypeName = t.TypepName;
        this.data.GoodsTypeId = t.RecordId;
      }
    },
    changeBelongColumn(val){
      this.loading();
      this.api.getMaxOrderId(val).then((res) => {
        this.loading(false)
        if (res.Code == 0) this.data.OrderId = res.Data;
      });
    },
    onCreateOpened(row) {
      this.getOption();
      this.api.getMaxOrderId(this.data.BelongColumn).then((res) => {
        if (res.Code == 0) this.data.OrderId = res.Data;
      });
    },
    onEditOpened(row) {
      this.getOption();
    },
    onBeforeSave() {},
    onClosed() {},
  },
};
</script>